import type {
  AddImportWidgetModuleFaults,
  AddImportWidgetModuleViaIFrameDisposeFaults,
  Disposable,
} from "@skbkontur/loader-builder";
import { importWidgetModule as importModule } from "@skbkontur/loader-builder";
import type { OperationResult } from "@skbkontur/operation-result";
import type { PlatformTypesConstraint } from "./index.js";
import type {
  AllNpmLoaderDependencies,
  ConfigureIframeDisposeFaults,
  Externals,
  JsLoaderImportFaults,
  ProvideExternalsFault,
} from "./private.js";
import { internalFieldSymbol } from "./private.js";

export type ImportParams<TPlatformTypes extends PlatformTypesConstraint> = {
  readonly widgetUrl: URL;
} & TPlatformTypes["ImportDependencies"];

export type ImportFaults<TPlatformTypes extends PlatformTypesConstraint> = AddImportWidgetModuleFaults<
  JsLoaderImportFaults<TPlatformTypes> | ProvideExternalsFault
>;

export type DisposeFaults<TPlatformTypes extends PlatformTypesConstraint> = AddImportWidgetModuleViaIFrameDisposeFaults<
  TPlatformTypes["DisposeFaults"],
  ConfigureIframeDisposeFaults
>;

export type WidgetApi<TPlatformTypes extends PlatformTypesConstraint> = Disposable<DisposeFaults<TPlatformTypes>> &
  TPlatformTypes["WidgetApi"];

export type ImportModuleResult<TPlatformTypes extends PlatformTypesConstraint> = Promise<
  OperationResult<ImportFaults<TPlatformTypes>, WidgetApi<TPlatformTypes>>
>;

export function importWidgetModule(externals: Externals) {
  return function <TPlatformTypes extends PlatformTypesConstraint>({
    widgetUrl,
    ...importDependencies
  }: ImportParams<TPlatformTypes>): ImportModuleResult<TPlatformTypes> {
    return importModule<
      AllNpmLoaderDependencies<TPlatformTypes>,
      JsLoaderImportFaults<TPlatformTypes>,
      WidgetApi<TPlatformTypes>
    >({
      widgetUrl,
      dependencies: {
        ...importDependencies,
        [internalFieldSymbol]: {
          externals,
        },
      },
    });
  };
}
